export default __webpack_public_path__ + "static/media/hajdu.f33ff0c1.jpg";